import axios from "axios";
import { createContext, useContext, useEffect, useReducer, useState } from "react";
import reducer from '../reducer/pitchReducer'

const AppContext = createContext();

const API = "https://tbc-backend.up.railway.app/pitch/get"
const WAIT_TIME = 2000;

const initialState = {
    isLoading: false,
    isError: false,
    singlePitch: {},
}

const AppProvider = ({ children }) => {  

    const [pitch, setPitch]=useState([])
    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        const id = setInterval(() => {
          axios
         .get(API)
         .then(res=>{
          setPitch(res.data);
         })
         .catch(err=>{
           console.log(err);
         })
        }, WAIT_TIME);
        return () => clearInterval(id);
      }, [pitch]); 

    const getSinglePitch = async (id) => {
        try {
            const res = await axios.get(`https://tbc-backend.up.railway.app/pitch/getOne/${id}`);
            const singlePitch = await res.data
            dispatch({ type: 'SET_SINGLE_PITCH', payload: singlePitch });
        } catch (error) {
            dispatch({ type: 'SINGLE_PITCH_API_ERROR' });
        }
    };

    return (
        <AppContext.Provider value={{ ...state, getSinglePitch, pitch }}>
            {children}
        </AppContext.Provider>
    )
}

const usePitchContext = () => {
    return useContext(AppContext);
}

export { AppProvider, AppContext, usePitchContext }

